import { store } from '@redux/store';
import GoogleAnalyticsEvent from "dataTransferObjects/googleAnalyticsEvent";
import uiStateSlice from 'layout/redux/uiStateSlice';

document.body.addEventListener('phoneAnchorClick', () => {
    const googleAnalyticsDTO = new GoogleAnalyticsEvent('TDV Events', 'Phone Number Views', 
    'PhoneNumber Displayed - Lead Form');
    store.dispatch(uiStateSlice.actions.trackUserEvent({ googleAnalyticsDTO }));
})

document.body.addEventListener('phoneAnchorTrackingClick', () => {
    const googleAnalyticsDTO = new GoogleAnalyticsEvent('TDV Events', 'Calls Placed', 
    'Convirza Phone Number Click-Lead Form');
    store.dispatch(uiStateSlice.actions.trackUserEvent({ googleAnalyticsDTO }));
})